import styled from 'styled-components';

import { ButtonV2 } from '@getgrover/ui';

export const CheckoutCta = styled(ButtonV2)`
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;
